/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PatchDocumentMetadataParams = {
  /**
   * The metadata to update on the document. Performs a partial update of the document's metadata. Keys must be strings. Values may be strings, numbers, booleans, or lists of strings. Numbers may be integers or floating point and will be converted to 64 bit floating point. Keys set to `null` are deleted. 1000 total values are allowed, inclusive of existing metadata. Each item in an array counts towards the total. The following keys are reserved for internal use: `document_id`, `document_type`, `document_source`, `document_name`, `document_uploaded_at`. If the document is managed by a connection, this operation will extend a metadata overlay which is applied to the document any time the connection syncs the document.
   */
  metadata: { [k: string]: any };
  /**
   * Whether to run the metadata update asynchronously. If true, the metadata update will be run in the background and the response will be 202. If false, the metadata update will be run synchronously and the response will be 200.
   */
  async?: boolean | undefined;
};

/** @internal */
export const PatchDocumentMetadataParams$inboundSchema: z.ZodType<
  PatchDocumentMetadataParams,
  z.ZodTypeDef,
  unknown
> = z.object({
  metadata: z.record(z.any()),
  async: z.boolean().default(false),
});
/** @internal */
export type PatchDocumentMetadataParams$Outbound = {
  metadata: { [k: string]: any };
  async: boolean;
};

/** @internal */
export const PatchDocumentMetadataParams$outboundSchema: z.ZodType<
  PatchDocumentMetadataParams$Outbound,
  z.ZodTypeDef,
  PatchDocumentMetadataParams
> = z.object({
  metadata: z.record(z.any()),
  async: z.boolean().default(false),
});

export function patchDocumentMetadataParamsToJSON(
  patchDocumentMetadataParams: PatchDocumentMetadataParams,
): string {
  return JSON.stringify(
    PatchDocumentMetadataParams$outboundSchema.parse(
      patchDocumentMetadataParams,
    ),
  );
}
export function patchDocumentMetadataParamsFromJSON(
  jsonString: string,
): SafeParseResult<PatchDocumentMetadataParams, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PatchDocumentMetadataParams$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PatchDocumentMetadataParams' from JSON`,
  );
}
